/* ==========================================================================
   Saki Shears — Custom Scripts
   --------------------------------------------------------------------------
   On theme update, recreate this file and re-add the script tag to
   layout/theme.liquid right before </body>:
     <script src="{{ 'saki-custom.js' | asset_url }}" defer></script>
   ==========================================================================
   Changes:
   2026-05-11  Intercept clicks on the zero-review rating fallback so the
               page scrolls to the top of the LAI review section instead of
               past it. Use instant scroll (Prestige eats smooth-scroll
               options). Offset 160px to clear the sticky announcement bar +
               product sticky Add-to-Cart bar at the top of the viewport.
   ========================================================================== */

(function () {
  var SCROLL_OFFSET = 160; // sticky announcement (44) + sticky cart bar (97) + 19 breathing room

  function bindReviewFallback() {
    var widgets = document.querySelectorAll('.scm-reviews-rate.click_star');
    widgets.forEach(function (widget) {
      if (!widget.querySelector('.lai-none-rating')) return;
      if (widget.dataset.sakiBound) return;
      widget.dataset.sakiBound = '1';

      widget.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        var target = document.querySelector('[id*="lai_product_reviews_lai_product_section"]');
        if (target) {
          var top = target.getBoundingClientRect().top + window.scrollY - SCROLL_OFFSET;
          window.scrollTo(0, top);
        }
      }, true);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindReviewFallback);
  } else {
    bindReviewFallback();
  }
  setTimeout(bindReviewFallback, 1000);
  setTimeout(bindReviewFallback, 3000);
})();